"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = void 0;
const Translate_1 = require("./Translate");
const translate = new Translate_1.Translate();
exports.translate = translate;
// @ts-ignore
if (typeof translations !== 'undefined') {
    // @ts-ignore
    translate.setTranslations(translations);
}
